import React, { useMemo, useState } from 'react';
import { DEPARTMENT_ORDER, JOB_DATA } from '../constants/jobData';
import JobCard from './JobCard';

function DepartmentLabel({ name }) {
  const bracketIndex = name.indexOf('（');
  if (bracketIndex < 0) return name;
  return (
    <>
      {name.slice(0, bracketIndex)}
      <span className="department-subline">{name.slice(bracketIndex)}</span>
    </>
  );
}

function JobsView({ hidden, onApply }) {
  const [activeDepartment, setActiveDepartment] = useState(DEPARTMENT_ORDER[0]);

  const jobs = useMemo(
    () => JOB_DATA.filter((job) => job.department === activeDepartment),
    [activeDepartment]
  );

  return (
    <section
      className="page-view jobs-view"
      id="jobs-view"
      role="tabpanel"
      hidden={hidden}
    >
      <main className="container page-main">
        <h1 className="page-title">招聘岗位</h1>
        <section className="jobs-layout">
          <div className="departments" id="departments" role="tablist" aria-label="招聘部门">
            {DEPARTMENT_ORDER.map((name) => (
              <button
                key={name}
                className={`department${name === activeDepartment ? ' active' : ''}`}
                type="button"
                role="tab"
                aria-selected={name === activeDepartment}
                onClick={() => setActiveDepartment(name)}
              >
                <DepartmentLabel name={name} />
              </button>
            ))}
          </div>
          <div className="results">
            <div className="results-head">
              <h2 id="department-title">{activeDepartment}</h2>
              <span id="result-count">共 {jobs.length} 个岗位</span>
            </div>
            <div className="job-list" id="job-list" role="tabpanel">
              {jobs.length ? (
                jobs.map((job) => <JobCard key={job.id} job={job} onApply={onApply} />)
              ) : (
                <div className="empty">该部门暂无招聘岗位</div>
              )}
            </div>
          </div>
        </section>
      </main>
    </section>
  );
}

export default JobsView;
